<template>
    <div class="table_wrap">
        <el-table :data="pointData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  height="695"
        >
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="90"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column min-width="" label="결제번호" prop="o_id" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.o_id }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="아이디" prop="mb_id" class-name="text-center">
                <template slot-scope="scope">
                    <el-link class="dgm-link" @click="moveProfile(scope.row.mb_no)">
                        {{ scope.row.mb_id }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="결제 방식" prop="o_payment" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{ returnOrderType(scope.row.o_payment) }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="결제 금액" prop="o_price" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{ returnCommas(scope.row.o_price) }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="" label="신청일자" prop="created_at" class-name="text-center">
                <template slot-scope="scope">
                    <span>{{ returnDate(scope.row.created_at) }}</span>
                </template>
            </el-table-column>

        </el-table>

    </div>

</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import {paymentType} from "@/service/pointService";
import util from "@/mixins/util";
import commonOptions from "@/mixins/commonOptions";
import EventBus from "@/utils/event-bus";

export default {
    name: "PointListChargeLayout",
    mixins: [dateMixins, alertMixins, commonOptions],
    components: {},
    inject: ['setPage', 'setFilter'],
    provide() {
        return {}
    },
    props: {
        pointType: '',
        pointData: {
            default: () => {
                return []
            }
        },
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnDate(date = null) {
            if (!date) {
                return '-';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        moveProfile(mb_no) {
            this.$router.push('/member/detail/' + mb_no)
        },
        returnOrderType(data) {
            if (data === 10) {
                return '카드'
            } else if (data === 1) {
                return '무통장 입금'
            } else if (data === 11) {
                return '실시간 계좌이체'
            } else if (data === 12) {
                return '가상계좌'
            } else if (data === 13) {
                return '휴대폰 결제'
            } else if (data === 30) {
                return '네이버 페이'
            } else if (data === 31) {
                return '카카오 페이'
            } else if (data === 32) {
                return '페이팔'
            }
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>
